module.exports = __webpack_public_path__ + "img/historia_3-4_512.caa89f71.webp";